module.exports = __webpack_public_path__ + "static/media/chef-1.8ae2f7cd.jpg";